import * as React from 'react';
import { clsx } from 'clsx';

import steps1 from './assets/steps_1.png';
import steps2 from './assets/steps_2.png';
import steps3 from './assets/steps_3.png';
import steps4 from './assets/steps_4.png';
import steps5 from './assets/steps_5.png';

import stepsMob1 from './assets/steps_mob_1.png';
import stepsMob2 from './assets/steps_mob_2.png';
import stepsMob3 from './assets/steps_mob_3.png';
import stepsMob4 from './assets/steps_mob_4.png';
import stepsMob5 from './assets/steps_mob_5.png';

import styles from './HowItWorksItem.css';

import { Step } from './Step';

interface IHowItWorksProps {
  step: string;
  title: string;
  description?: string;
  isLtr: boolean;
}

const STEPS_IMAGES = {
  '1': steps1,
  '2': steps2,
  '3': steps3,
  '4': steps4,
  '5': steps5,
};
const STEPS_MOB_IMAGES = {
  '1': stepsMob1,
  '2': stepsMob2,
  '3': stepsMob3,
  '4': stepsMob4,
  '5': stepsMob5,
};

export const HowItWorksItem: React.FC<IHowItWorksProps> = ({
  step,
  title,
  description,
  isLtr,
}: React.PropsWithChildren<IHowItWorksProps>) => {
  return (
    <div className={clsx(styles['item'], isLtr && styles['item-ltr'])}>
      <div className={styles['content']}>
        <Step step={step} />
        <div className={styles['title']}>{title}</div>
        {description && <div className={styles['description']}>{description}</div>}
      </div>
      <div className={styles['image']}>
        <picture className={styles['picture']}>
          <source
            media="(max-width: 639px)"
            srcSet={STEPS_MOB_IMAGES[step as keyof typeof STEPS_MOB_IMAGES]}
            type="image/png"
          />
          <source
            media="(min-width: 640px)"
            srcSet={STEPS_IMAGES[step as keyof typeof STEPS_IMAGES]}
            type="image/png"
          />
          <img src={STEPS_IMAGES[step as keyof typeof STEPS_IMAGES]} alt={title} loading="lazy" decoding="async" />
        </picture>
      </div>
    </div>
  );
};
